import { Wording } from '@/types';

export const ASTROLOGY_WORDING_PL: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Medytacje',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Przewodniki',
  components_header_text2: 'Blog',
  components_header_members: 'Członkowie',
  hero_text: 'Odkryj gwiazdy wewnątrz',
  hero_button_text: 'Zacznij tutaj',
  components_ressources_section_title: 'ZASOBY',
  components_ressources_subheader_text: 'Wszystkie narzędzia potrzebne do kosmicznego wglądu i samopoznania',
  components_ressources_span_text: 'Rozszerz swój wewnętrzny wszechświat dzięki starannie dobranej mieszance podcastów i artykułów. Niezależnie od tego, czy szukasz kosmicznego wglądu, jasności czy duchowego wyrównania, nasze zasoby pomagają Ci połączyć się z astrologią w praktyczny, znaczący sposób.',
  components_ressources_card_1_title: 'Głębokie nurkowania',
  components_ressources_card_1_text: 'Zanurz się w bogatej kolekcji dogłębnych podcastów obejmujących astrologię, tarota, archetypy kosmiczne i rozwój duchowy — zaprojektowanych w celu poszerzenia Twojej świadomości i pogłębienia Twojej praktyki.',
  components_ressources_card_2_title: 'Spostrzeżenia dotyczące gwiazd',
  components_ressources_card_2_text: 'Astrologiczne wskazówki i wpisy na blogu dotyczące samoświadomości i rozwoju duchowego.',
  components_ressources_link: 'Odkryj więcej',
  components_notes_and_google_title_1: 'Wskazówki astrologiczne',
  components_notes_and_google_title_2: 'Rutyna kosmiczna',
  components_notes_and_google_title_3: 'Odbicia',
  components_review_google_text: 'Recenzje',
  media_content_section_title: 'AUDIO',
  media_content_section_subheader_text: 'Nasz podcast',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Więcej odcinków',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Artykuły i spostrzeżenia',
  text2_section_button_more: 'Załaduj więcej',
  components_text1_section_title: 'PRZEWODNIKI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Zobacz wszystkie przewodniki',
  components_footer_text: 'Obudź swój wewnętrzny kosmos: Twoją ścieżkę, Twoje gwiazdy.',
  components_footer_info: 'Informacje',
  components_footer_registration_number: 'Numer rejestracyjny',
  components_footer_legal: 'Prawny',
  components_footer_terms: 'Warunki i postanowienia',
  components_footer_privacy: 'Polityka prywatności',
  button_load_more: 'Załaduj więcej',
  page_media_1_content_hero_text: 'Odcinki podcastów',
  page_media_content_menu_foundations: 'Podwaliny',
  page_media_content_menu_spirituality: 'Duchowość',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psychologia',
  page_media_content_menu_trends: 'Trendy',
  page_media_2_content_hero_text: 'Nośniki 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Nasz blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Artykuły i spostrzeżenia',
  enter_email_title: 'Proszę wpisać swój adres e-mail, aby kontynuować',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Wchodzić',
  components_login_success_text: 'Logowanie pomyślne!',
  components_card_link_media_content: 'Słuchaj teraz',
  components_card_link_text1_content: 'Zobacz przewodnik',
  components_card_link_text2_content: 'Zobacz artykuł',
  france: 'Francja',
  cyprus: 'Cypr',
  tag_podcast: 'Podcast',
  tag_meditation: 'Medytacja',
  page_media_content_menu_all: 'Wszystko',
};